export default {"src":"/_next/static/media/ic_XButton_black.fe961b93.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};